export default __webpack_public_path__ + "static/media/image_transak.1710463e.png";